import { render, staticRenderFns } from "./DashboardReportCredit.vue?vue&type=template&id=5251ca7b&scoped=true"
import script from "./DashboardReportCredit.vue?vue&type=script&lang=js"
export * from "./DashboardReportCredit.vue?vue&type=script&lang=js"
import style0 from "./DashboardReportCredit.vue?vue&type=style&index=0&id=5251ca7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5251ca7b",
  null
  
)

export default component.exports